import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Carrentalmumbai() {



  const cardData =
  {
    keyword: 'Car Rental In Mumbai ',
    heading: 'Shambhu Cabs: Car Rental In Mumbai',
    headingDescription: 'Shambhu Cabs offers reliable Car Rental in Mumbai, providing safe, comfortable, and convenient travel for families, corporate travelers, business professionals, and tourists across the city. Our fleet of well-maintained hatchbacks, sedans, SUVs, and luxury cars ensures smooth and enjoyable rides for airport transfers, city commuting, outstation trips, and full-day rentals. With professional chauffeurs, flexible one-way and round-trip options, doorstep pickup across South Mumbai, Thane, Andheri, Navi Mumbai, and 24/7 booking support, Shambhu Cabs makes car rental in Mumbai hassle-free, timely, and convenient. For comfort, safety, and a trusted travel experience, Shambhu Cabs is your preferred choice for car rental in Mumbai.',

    top: 'Top Places to Visit in Mumbai with Shambhu Cabs',

 
"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India, built in 1924, is Mumbai’s iconic stone arch commemorating the visit of King George V and Queen Mary. Overlooking the Arabian Sea, it stands as a historic entry point for British governors and a symbol of colonial-era architecture. Visitors enjoy ferry rides to Elephanta Island, street food stalls, coastal photography, and a lively promenade. Its illuminated evenings create a stunning waterfront ambiance that reflects the essence of Mumbai."
  },
  {
    "title": "Marine Drive (Queen’s Necklace)",
    "description": "Marine Drive is Mumbai’s famous 3.6 km-long coastline, known for its curved boulevard that glitters like a ‘Queen’s Necklace’ at night. The promenade is ideal for morning jogs, romantic walks, cycling, and enjoying refreshing sea breezes. The Art Deco buildings lining the stretch add heritage value, making it one of the world’s largest collections of Art Deco architecture. Sunsets here are especially mesmerizing, drawing locals, tourists, and photographers to soak in the city’s vibrant coastal charm."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
    "description": "CSMT, a UNESCO World Heritage Site, is an architectural masterpiece blending Victorian Gothic Revival and Indian traditional designs. Built in 1887, it is one of India’s busiest railway stations and a symbol of Mumbai’s historic importance. Its grand domes, stained glass windows, carvings of flora and fauna, and intricate pillars make it a living museum. The nighttime lighting further enhances its majesty, making it a must-visit landmark for history, architecture, and photography enthusiasts."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is Mumbai’s most popular beach, famous for its vibrant street food culture, local entertainers, and stunning sunsets. Visitors indulge in Mumbai’s iconic snacks like pav bhaji, bhel puri, and gola while enjoying camel rides, kite flying, and beach sports. The beach is also frequently visited by Bollywood celebrities who live in the surrounding areas. Its lively yet relaxed atmosphere makes it a perfect escape for families, couples, and tourists."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Shree Siddhivinayak Temple in Prabhadevi is one of India’s most revered Ganesha temples, believed to fulfill devotees’ wishes. The temple’s wooden doors depict Ashtavinayak carvings, and the gold-plated sanctum adds to its spiritual aura. Thousands queue up daily for darshan, including celebrities and leaders. During Ganesh Chaturthi, the entire area comes alive with devotional music, lights, and vibrant processions, showcasing Mumbai’s deep spiritual culture."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah, situated on an islet connected by a narrow causeway, is a stunning Indo-Islamic structure honoring Sufi saint Pir Haji Ali Shah Bukhari. Surrounded by the sea on all sides, it offers breathtaking views and a serene spiritual experience. The white marble structure, religious hymns, and peaceful setting attract visitors of all faiths. The walk to the dargah during low tide is a unique experience, blending spirituality with natural beauty."
  },
  {
    "title": "Elephanta Caves",
    "description": "The Elephanta Caves, a UNESCO World Heritage Site located on Elephanta Island, feature ancient rock-cut sculptures dedicated primarily to Lord Shiva. The 5th–8th century caves include magnificent carvings like the massive Trimurti (three-faced Shiva), Nataraja, and various mythological scenes. Visitors reach the island via ferry from the Gateway of India, experiencing a combination of history, art, nature, and coastal adventure."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "description": "The Bandra-Worli Sea Link is a modern engineering marvel connecting Mumbai’s western suburbs to South Mumbai. Its cable-stayed architecture, sweeping curves, and views of the Arabian Sea make it a visual delight. The bridge significantly reduces travel time and symbolizes Mumbai’s urban growth. Sunrise, sunset, and nighttime views with illuminated cables provide spectacular photographic opportunities."
  },
  {
    "title": "Chor Bazaar",
    "description": "Chor Bazaar, one of India’s oldest and most famous flea markets, is renowned for antiques, vintage Bollywood memorabilia, gramophones, cameras, and rare collectibles. Walking through its busy lanes offers a glimpse into Mumbai’s historic trade culture. Bargain hunters, designers, and collectors explore the market to discover unique treasures. The chaotic yet vibrant atmosphere makes it an exciting spot for cultural enthusiasts and photographers."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Sanjay Gandhi National Park spans over 100 sq km in northern Mumbai, serving as a biodiversity hotspot and city escape. Visitors enjoy nature trails, lion and tiger safaris, boating, cycling, and trekking. The ancient Kanheri Caves within the park provide historical and archaeological interest. Home to leopards, monkeys, deer, and hundreds of bird species, it offers a jungle retreat in the middle of the city, perfect for adventure and nature enthusiasts."
  },
  {
    "title": "Mount Mary Church",
    "description": "The Basilica of Our Lady of the Mount, popularly called Mount Mary Church, is a Roman Catholic church atop a hill in Bandra. Known for its Gothic architecture, peaceful interiors, and panoramic views of the sea, it attracts devotees and tourists alike. The annual Bandra Fair in September draws large crowds for prayers, cultural programs, and local food. The church symbolizes Mumbai’s religious harmony and cultural diversity."
  },
  {
    "title": "Global Vipassana Pagoda",
    "description": "The Global Vipassana Pagoda in Gorai is a massive meditation hall and a monument to peace. Featuring the world’s largest stone dome built without supporting pillars, it serves as a center for learning Vipassana meditation. The pagoda’s serene atmosphere, golden interiors, and scenic gardens attract spiritual seekers and tourists. Visitors gain insight into India’s meditation traditions while enjoying panoramic views of the surrounding landscapes."
  }
],



"services": [
  {
    "name": "Car Hire Mumbai",
    "description": "Car Hire Mumbai offers a wide range of vehicles for city travel, airport transfers, and outstation trips, providing convenience, comfort, and professional service."
  },
  {
    "name": "Self-Drive Cars Mumbai",
    "description": "Self-Drive Cars Mumbai allows customers to rent cars and drive at their own pace, ideal for personal trips, sightseeing, and weekend getaways."
  },
  {
    "name": "Chauffeur Car Rental Mumbai",
    "description": "Chauffeur Car Rental Mumbai provides professional drivers for stress-free travel across Mumbai and surrounding cities, ensuring safety and punctuality."
  },
  {
    "name": "Local Car Rental Mumbai",
    "description": "Local Car Rental Mumbai offers short-term city rides for errands, office commutes, and local sightseeing with clean and well-maintained vehicles."
  },
  {
    "name": "Outstation Car Hire Mumbai",
    "description": "Outstation Car Hire Mumbai caters to long-distance travel, weekend trips, and intercity journeys with comfortable cars and experienced drivers."
  },
  {
    "name": "Airport Car Rental Mumbai",
    "description": "Airport Car Rental Mumbai ensures timely airport pickups and drops with spacious, AC-equipped vehicles for a hassle-free travel experience."
  },
  {
    "name": "Affordable Car Rental Services",
    "description": "Affordable Car Rental Services Mumbai offers budget-friendly car hire options without compromising on comfort, safety, or reliability."
  },
  {
    "name": "Premium Car Hire Mumbai",
    "description": "Premium Car Hire Mumbai provides luxury vehicles for special occasions, business trips, or premium travel experiences with professional chauffeurs."
  },
  {
    "name": "Sedan Rental Mumbai",
    "description": "Sedan Rental Mumbai offers comfortable and efficient sedans for city rides, airport transfers, and outstation travel at competitive rates."
  },
  {
    "name": "SUV Rental Mumbai",
    "description": "SUV Rental Mumbai delivers spacious and powerful SUVs suitable for family trips, group travel, and long-distance journeys with comfort and style."
  },
  {
    "name": "Luxury Car Rental Mumbai",
    "description": "Luxury Car Rental Mumbai features premium vehicles such as Mercedes, BMW, and Audi for weddings, events, corporate travel, and VIP services."
  },
  {
    "name": "Daily Car Rental Mumbai",
    "description": "Daily Car Rental Mumbai allows flexible 24-hour car hire for short-term city travel or outstation trips with transparent pricing and reliable service."
  },
  {
    "name": "Weekly Car Rental",
    "description": "Weekly Car Rental Mumbai provides affordable rates for long-term rentals, ideal for extended trips, business projects, or family vacations."
  },
  {
    "name": "Monthly Car Rental Mumbai",
    "description": "Monthly Car Rental Mumbai offers cost-effective car hire solutions for long-term needs, corporate employees, or residents requiring regular transport."
  },
  {
    "name": "Corporate Car Rental Mumbai",
    "description": "Corporate Car Rental Mumbai provides premium and reliable transport solutions for businesses, employee commute, client meetings, and corporate events."
  },
  {
    "name": "Online Car Booking Mumbai",
    "description": "Online Car Booking Mumbai allows users to conveniently book cars via apps or websites for city rides, airport transfers, or outstation trips."
  },
  {
    "name": "Best Car Rental Near Me",
    "description": "Best Car Rental Near Me Mumbai connects users to the nearest trusted car rental services offering a variety of vehicles at competitive rates."
  }
],

"tableData": [
  ["Car Hire Mumbai", "Self-Drive Cars Mumbai"],
  ["Chauffeur Car Rental Mumbai", "Local Car Rental Mumbai"],
  ["Outstation Car Hire Mumbai", "Airport Car Rental Mumbai"],
  ["Affordable Car Rental Services", "Premium Car Hire Mumbai"],
  ["Sedan Rental Mumbai", "SUV Rental Mumbai"],
  ["Luxury Car Rental Mumbai", "Daily Car Rental Mumbai"],
  ["Weekly Car Rental", "Monthly Car Rental Mumbai"],
  ["Corporate Car Rental Mumbai", "Online Car Booking Mumbai"],
  ["Best Car Rental Near Me", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Car Rental in Mumbai with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs offers reliable car rental services in Mumbai, perfect for city travel, airport transfers, business trips, and family outings."
  },
  {
    "WhyChooseheading": "Wide Range of Well-Maintained Cars",
    "WhyChoosedescription": "Choose from a variety of clean, air-conditioned, and regularly serviced cars to ensure a comfortable and smooth ride across Mumbai."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Safe Journeys",
    "WhyChoosedescription": "Our professional drivers are familiar with Mumbai routes, ensuring timely, safe, and hassle-free travel in all types of rental cars."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "We provide clear, upfront pricing—fuel, tolls, and driver allowances included—making your car rental experience stress-free and reliable."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist with bookings, travel queries, and real-time updates."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans",
    "WhyChoosedescription": "Choose from hourly, daily, or customized rental plans tailored to your car rental needs in Mumbai."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All rental cars are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and smooth service, making your car rental in Mumbai convenient and worry-free."
  }
]



















  }

const faqData = [
  {
    question: 'Does Shambhu Cabs provide car rental services in Mumbai?',
    answer: 'Yes, Shambhu Cabs offers reliable and comfortable car rental services in Mumbai for local travel, airport transfers, and outstation trips.',
  },
  {
    question: 'How can I book a car rental in Mumbai with Shambhu Cabs?',
    answer: 'You can book easily through our website, mobile app, or by contacting our 24x7 customer support team for a hassle-free booking experience.',
  },
  {
    question: 'What types of cars are available for rental in Mumbai?',
    answer: 'Shambhu Cabs offers a wide range of vehicles including sedans, SUVs, hatchbacks, premium cars, and tempo travellers suitable for various travel needs.',
  },
  {
    question: 'Are drivers experienced for car rentals in Mumbai?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with Mumbai routes to ensure a safe and timely journey.',
  },
  {
    question: 'Can I choose custom pickup and drop-off locations for car rentals in Mumbai?',
    answer: 'Absolutely. You can select any pickup and drop-off points within Mumbai or for outstation trips according to your convenience.',
  },
  {
    question: 'Is car rental service available 24x7 in Mumbai?',
    answer: 'Yes, Shambhu Cabs provides round-the-clock car rental services to accommodate any travel schedule.',
  },
  {
    question: 'Are safety and hygiene protocols followed for car rentals in Mumbai?',
    answer: 'All vehicles are sanitized regularly, and drivers follow strict hygiene and safety measures to ensure passenger well-being.',
  },
  {
    question: 'What payment options are available for car rentals in Mumbai?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate account payments for all car rental bookings.',
  },
  {
    question: 'Is customer support available during car rental trips in Mumbai?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your car rental journey in Mumbai.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohit Mehra',
    feedback: 'Renting a car from Shambhu Cabs in Mumbai was easy and convenient. Professional driver and well-maintained car made our trip smooth.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Priya Kapoor',
    feedback: 'Highly recommend Shambhu Cabs for car rentals in Mumbai. Excellent service and punctual drivers ensured a hassle-free journey.',
    rating: 5,
  },
];



































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Car Rental in Mumbai",
  "image": "https://www.shambhucab.com/assets/images/car-rental-mumbai.jpg",
  "description": "Shambhu Cabs offers car rental services in Mumbai including self-drive cars, chauffeur-driven cars, airport transfers, local rides, outstation trips, and corporate rentals. Affordable, premium, and luxury car options available for daily, weekly, or monthly rentals.",
  "brand": {
    "@type": "Brand",
    "name": "Shambhu Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "1050",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1200",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/car-rental-mumbai"
  }
};





  return (
    <div>
<Helmet>
  <title>Car Rental in Mumbai | Self-Drive & Chauffeur Cars | Shambhu Cabs</title>

  <meta
    name="description"
    content="Rent cars in Mumbai with Shambhu Cabs. Choose self-drive or chauffeur-driven cars for local rides, airport transfers, outstation trips, and corporate rentals. Affordable and premium options available."
  />

  <meta
    name="keywords"
    content="Car Hire Mumbai, Self-Drive Cars Mumbai, Chauffeur Car Rental Mumbai, Local Car Rental Mumbai, Outstation Car Hire Mumbai, Airport Car Rental Mumbai, Affordable Car Rental Services, Premium Car Hire Mumbai, Sedan Rental Mumbai, SUV Rental Mumbai, Luxury Car Rental Mumbai, Daily Car Rental Mumbai, Weekly Car Rental, Monthly Car Rental Mumbai, Corporate Car Rental Mumbai, Online Car Booking Mumbai, Best Car Rental Near Me"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/51.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Carrentalmumbai;